import {QueryClient, useQuery} from "react-query";
import * as api from "../api/offices";

const getOffice = async (officeId) => {
    return await api.fetchOffice(officeId);
};

export default function useOffice(officeId) {
    return useQuery([
        'office',
        {officeId}
    ], () => getOffice(officeId), {refetchOnWindowFocus: false});
}
